export type AppRole = "superadmin" | "admin";

export type AppNavItem = {
  to: string;
  label: string;
  /** When true, only superadmin shell shows this item. */
  superadminOnly?: boolean;
};

export const APP_NAV_ITEMS: AppNavItem[] = [
  { to: "/agents", label: "Agents" },
  { to: "/run-launch", label: "Run Launch", superadminOnly: true },
  { to: "/evaluate", label: "Evaluate" },
  { to: "/runs", label: "Runs" },
  { to: "/dashboard", label: "Dashboard" },
  { to: "/diagnostics", label: "Diagnostics", superadminOnly: true },
  { to: "/scheduler", label: "Scheduler", superadminOnly: true },
  { to: "/metrics", label: "Metrics", superadminOnly: true },
];

export const SUPERADMIN_ONLY_PATHS = APP_NAV_ITEMS.filter((item) => item.superadminOnly).map(
  (item) => item.to,
);

export function navItemsForRole(role: AppRole): AppNavItem[] {
  if (role === "superadmin") return APP_NAV_ITEMS;
  return APP_NAV_ITEMS.filter((item) => !item.superadminOnly);
}

export function isSuperadminOnlyPath(pathname: string): boolean {
  const path = pathname.startsWith("/") ? pathname : `/${pathname}`;
  return SUPERADMIN_ONLY_PATHS.some((p) => path === p || path.startsWith(`${p}/`));
}
